import { useMatchAny } from "src/hooks/useMatchAny";
import { personalDashboardPaths } from "src/routes/routesDef";

export function usePersonalDashboardActivityPageRouteMatch(): { isDashboardActivityPage: boolean } {
  const isDashboardActivityPage = !!useMatchAny([personalDashboardPaths.activity]);
  return { isDashboardActivityPage };
}
